import { css } from 'lit';

export const inputMaterial = css`
  .jr-input-material,
  .jr-typeahead-input {
    width: 100%;
    height: 45px;
    font-size: 16px;
  }
  .jr-typeahead-input {
    padding: 0 15px;
    border: 2px solid #fff;
    border-radius: 5px;
    background-color: #fff;
    color: #b7b7b7;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
  }
  .jr-input-material {
    position: relative;
    background-color: transparent;
    color: #0f0f0f;
    padding: 0 16px;
    border: 1px solid #9b9b9b;
    border-radius: 4px;
    line-height: 24px;
    z-index: 11;
  }
  .jr-input-material--disabled {
    border: none;
    color: #9b9b9b;
    background-color: #f3f3f3;
  }
  .jr-input-material--invalid {
    border: 1px solid #ff0322;
  }
  .jr-input-material:focus {
    outline: 0;
    box-shadow: 0 0 0 2px #ff206e;
  }
  .jr-input-material:focus ~ .proposal-form__label {
    display: block;
  }
  .jr-input-material:placeholder-shown ~ .clear-button,
  .jr-input-material:placeholder-shown ~ .warning-button {
    display: none;
  }
  .jr-input-material:-moz-placeholder ~ .clear-button,
  .jr-input-material:placeholder-shown ~ .warning-button {
    display: none;
  }
  .jr-input-material::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }
  @media (min-width: 768px) {
    .jr-input-material--disabled {
      border: 1px solid #cfcfcf;
    }
  }
`